import { typographyV2 } from '@toggle/design-system';
import styled, { css } from 'styled-components';

export const Root = styled.div<{ $variant: 'primary' | 'secondary' }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${({ $variant }) => ($variant === 'primary' ? '8px' : '4px')};
`;

export const TitleLabel = styled.div<{ $variant: 'primary' | 'secondary' }>`
  ${({ $variant }) =>
    $variant === 'primary'
      ? css`
          ${typographyV2.titleMd};
        `
      : css`
          ${typographyV2.titleSm};
          color: var(--text-soft);
        `}
`;

export const TextContentWrapper = styled.div`
  ${typographyV2.bodyBase};
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`;

export const BulletItem = styled.div`
  padding: 0 6px;

  &::after {
    content: '•';
  }
`;
